document.addEventListener("DOMContentLoaded", () => {
  const MOBILE_MAX = 749;

  const table = document.querySelector("table.table");
  if (!table) return;

  const wrapper =
    document.querySelector(".table_scroll_wrapper") ||
    table.parentElement ||
    table;

  const headerCell = document.querySelector(".dynamic-header-cell");
  const headerItems = headerCell ? [...headerCell.querySelectorAll(".dynamic-item")] : [];
  const bodyCols   = [...document.querySelectorAll(".dynamic_column")];

  if (!headerCell || !headerItems.length || !bodyCols.length) return;

  function getFirstColWidth() {
    const firstHeaderTd = table.querySelector(".ingredient_title_top");
    const firstBodyTd   = table.querySelector(".ingredient_title");
    const base = firstHeaderTd || firstBodyTd;
    return base ? Math.ceil(base.getBoundingClientRect().width) : 160;
  }

  const stateCount = headerItems.length;
  let colW = 0, firstColW = 0, posX = 0;
  let headerTrack = null;
  const bodyTracks = [];

  const SNAPS          = [0, 189, 356]; 
  const INACTIVITY_MS  = 2000;          
  const STEP_MS        = 4000;          

  function makeViewportWithTrack(tdContainer, items, isBody = false) {
    tdContainer.style.width    = `${colW}px`;
    tdContainer.style.minWidth = `${colW}px`;
    tdContainer.style.maxWidth = `${colW}px`;
    tdContainer.style.position = tdContainer.style.position || "relative";
    tdContainer.style.padding  = tdContainer.style.padding  || "0";

    const viewport = document.createElement("div");
    viewport.setAttribute("data-viewport", "true");
    viewport.style.overflow  = "hidden";
    viewport.style.position  = "relative";
    viewport.style.display   = "block";
    viewport.style.width     = `${colW}px`;

    const track = document.createElement("div");
    track.setAttribute("data-track", "true");
    track.style.display       = "flex";
    track.style.flexDirection = "row";
    track.style.flexWrap      = "nowrap";
    track.style.willChange    = "transform";
    track.style.transform     = "translateX(0px)";

    items.forEach((el) => {
      el.style.display  = "block";
      el.style.flex     = `0 0 ${colW}px`;
      el.style.minWidth = `${colW}px`;
      el.style.maxWidth = `${colW}px`;
      el.style.position = "relative";
      if (isBody) {
        el.setAttribute("aria-hidden", "false");
        el.classList.add("is-active");
      }
      if (el.style.removeProperty) el.style.removeProperty("visibility");
      track.appendChild(el);
    });

    tdContainer.textContent = "";
    viewport.appendChild(track);
    tdContainer.appendChild(viewport);

    return { viewport, track };
  }

  function layout() {
    if (window.innerWidth > MOBILE_MAX) return;

    firstColW = getFirstColWidth();
    const viewportTotalW = wrapper.clientWidth || window.innerWidth;
    colW = Math.max(120, viewportTotalW - firstColW);

    wrapper.style.overflowX = "hidden";
    wrapper.style.overflowY = wrapper.style.overflowY || "hidden";
    wrapper.style.webkitOverflowScrolling = "touch";
    wrapper.style.position = wrapper.style.position || "relative";
    wrapper.style.touchAction = "pan-y";

    const { track: hTrack } = makeViewportWithTrack(headerCell, headerItems, false);
    headerTrack = hTrack;

    bodyTracks.length = 0;
    bodyCols.forEach((td) => {
      const states = [...td.querySelectorAll(".state")];
      if (!states.length) return;
      const { track: bTrack } = makeViewportWithTrack(td, states, true);
      bodyTracks.push(bTrack);
    });

    posX = 0;
    applyTransform();
  }

  function applyTransform() {
    const maxX = (stateCount - 1) * colW;
    if (posX < 0) posX = 0;
    if (posX > maxX) posX = maxX;
    const tx = `translateX(-${posX}px)`;
    if (headerTrack) headerTrack.style.transform = tx;
    bodyTracks.forEach((t) => (t.style.transform = tx));
  }

  function easeOutCubic(t){ return 1 - Math.pow(1 - t, 3); }

  let snapAnimId = null;
  function cancelSnapAnim() {
    if (snapAnimId) cancelAnimationFrame(snapAnimId);
    snapAnimId = null;
  }

  function nearestSnap(x) {
    let best = SNAPS[0], bd = Math.abs(x - SNAPS[0]);
    for (let i = 1; i < SNAPS.length; i++) {
      const d = Math.abs(x - SNAPS[i]);
      if (d < bd) { bd = d; best = SNAPS[i]; }
    }
    return best;
  }

  function animateTo(target, duration = 260) {
    cancelSnapAnim();
    const start = posX;
    const dist  = target - start;
    if (Math.abs(dist) < 0.5 || duration <= 0) {
      posX = target; applyTransform(); return;
    }
    const t0 = performance.now();
    function step(t) {
      const p = Math.min(1, (t - t0) / duration);
      posX = start + dist * easeOutCubic(p);
      applyTransform();
      if (p < 1) snapAnimId = requestAnimationFrame(step);
      else { snapAnimId = null; posX = target; applyTransform(); }
    }
    snapAnimId = requestAnimationFrame(step);
  }

  function snapToNearest(duration = 260) {
    animateTo(nearestSnap(posX), duration);
  }

  let dragging = false, startX = 0, startY = 0, startPos = 0;
  let v = 0, rafId = null, lastT = 0;

  let gestureLock = null;
  const ANGLE_THRESHOLD = 6;

  const trail = [];
  const TRAIL_MAX = 6;

  function momentumStep(t) {
    if (!lastT) lastT = t;
    const dt = t - lastT;
    lastT = t;

    const FRICTION = 0.0028;
    posX += v * dt;
    v *= Math.max(0, 1 - FRICTION * dt);

    const maxX = (stateCount - 1) * colW;
    if (posX < 0) { posX = 0; v = 0; }
    else if (posX > maxX) { posX = maxX; v = 0; }

    applyTransform();

    if (Math.abs(v) < 0.02) {
      cancelAnimationFrame(rafId);
      rafId = null;
      snapToNearest();
      return;
    }
    rafId = requestAnimationFrame(momentumStep);
  }

  function startMomentum(initialV) {
    if (rafId) cancelAnimationFrame(rafId);
    cancelSnapAnim();
    v = initialV || 0;
    lastT = 0;
    rafId = requestAnimationFrame(momentumStep);
  }

  function stopMomentum() {
    if (rafId) cancelAnimationFrame(rafId);
    rafId = null; v = 0; lastT = 0;
  }

  function onDown(x, y) {
    dragging = true;
    gestureLock = null;
    startX = x; startY = y; startPos = posX;
    trail.length = 0; trail.push({ t: performance.now(), x });
    stopMomentum(); cancelSnapAnim(); resetInactivity();
  }

  function onMove(x, y, e) {
    if (!dragging) return;
    const dx = x - startX, dy = y - startY;

    if (gestureLock == null) {
      if (Math.abs(dx) > Math.abs(dy) + ANGLE_THRESHOLD) gestureLock = 'h';
      else if (Math.abs(dy) > Math.abs(dx) + ANGLE_THRESHOLD) gestureLock = 'v';
      else return;
    }
    if (gestureLock === 'v') return;

    const now = performance.now();
    posX = startPos - dx;
    applyTransform();

    trail.push({ t: now, x });
    if (trail.length > TRAIL_MAX) trail.shift();

    if (e) e.preventDefault();
  }

  function onUp() {
    if (!dragging) return;
    dragging = false;
    if (gestureLock !== 'h') return;

    const now = performance.now();
    let i = trail.length - 1, j = i;
    while (j > 0 && now - trail[j].t < 120) j--;
    const a = trail[j], b = trail[i];
    const dt = b.t - a.t, dx = b.x - a.x;
    const initialV = dt > 0 ? (-dx / dt) : 0;

    if (Math.abs(initialV) > 0.05) startMomentum(initialV);
    else snapToNearest();

    resetInactivity();
  }

  wrapper.addEventListener("mousedown", (e) => onDown(e.pageX, e.pageY));
  window.addEventListener("mousemove", (e) => onMove(e.pageX, e.pageY, e));
  window.addEventListener("mouseup", onUp);

  wrapper.addEventListener("touchstart", (e) => {
    const t = e.touches[0]; onDown(t.pageX, t.pageY);
  }, { passive: true });

  wrapper.addEventListener("touchmove", (e) => {
    const t = e.touches[0]; onMove(t.pageX, t.pageY, e);
  }, { passive: false });

  wrapper.addEventListener("touchend", onUp);

  let wheelSnapTimer = null;
  wrapper.addEventListener("wheel", (e) => {
    const absX = Math.abs(e.deltaX), absY = Math.abs(e.deltaY);
    if (absX > absY) {
      stopMomentum(); cancelSnapAnim();
      posX += e.deltaX; applyTransform();
      e.preventDefault();
      startMomentum(e.deltaX / 16.6);
      clearTimeout(wheelSnapTimer);
      wheelSnapTimer = setTimeout(() => { stopMomentum(); snapToNearest(); }, 140);
      resetInactivity();
    }
  }, { passive: false });

  let autoTimer = null;
  let autoInterval = null;
  const sequence = [0, 1, 2, 1]
  let seqPtr = 0;

  function goToIndex(i) {
    const target = SNAPS[i] || 0;
    stopMomentum(); cancelSnapAnim();
    animateTo(target, 260);
  }

  function startAuto() {
    if (autoInterval) return;
    const curIdx = SNAPS.indexOf(nearestSnap(posX));
    const startPtr = sequence.indexOf(curIdx);
    seqPtr = startPtr >= 0 ? startPtr : 0;
  
    seqPtr = (seqPtr + 1) % sequence.length;
    goToIndex(sequence[seqPtr]);
  
    autoInterval = setInterval(() => {
      seqPtr = (seqPtr + 1) % sequence.length;
      goToIndex(sequence[seqPtr]);
    }, STEP_MS);
  }

  function stopAuto() {
    if (autoInterval) { clearInterval(autoInterval); autoInterval = null; }
  }

  function resetInactivity() {
    stopAuto();
    if (autoTimer) clearTimeout(autoTimer);
    autoTimer = setTimeout(startAuto, INACTIVITY_MS);
  }

  document.addEventListener("visibilitychange", () => {
    if (document.hidden) { stopAuto(); }
    else { resetInactivity(); }
  });

  let rt;
  function onResize() {
    clearTimeout(rt);
    rt = setTimeout(() => {
      stopMomentum(); cancelSnapAnim(); stopAuto();
      const prevColW = colW;
      layout();
      if (prevColW !== colW) snapToNearest(0);
      else applyTransform();
      resetInactivity();
    }, 120);
  }

  layout();
  window.addEventListener("resize", onResize, { passive: true });

  resetInactivity();
});


(() => {
  const tbl = document.querySelector('.product-comparison-chart .comparison-chart-table');
  if (!tbl) return;

  const bullets = document.querySelectorAll('.product-comparison-chart .bullet-pagination li');
  const row = (tbl.tBodies[0]?.rows[0]) || tbl.rows[0];
  const c1  = row?.cells[0];
  const c2  = row?.cells[1];

  const SNAP_2        = 140;    
  const EPS           = 6;      
  const INACTIVITY_MS = 2000;   
  const STEP_MS       = 1000;   

  let raf = null;
  let autoTimer = null;
  let autoInterval = null;
  let autoDir = 1

  const schedule = () => { if (raf == null) raf = requestAnimationFrame(update); };

  function setActive(first) {
    if (bullets.length < 2) return;
    bullets[0].classList.toggle('active-bull',  first);
    bullets[1].classList.toggle('active-bull', !first);
  }

  function updateBullets() {
    const x = tbl.scrollLeft;
    if (Math.abs(x - 0) <= EPS) {
      setActive(true);
    } else if (x >= (SNAP_2 - EPS)) {
      setActive(false);
    } else {
      setActive(x < SNAP_2 / 2);
    }
  }

  function update() {
    raf = null;
    if (c1) tbl.style.setProperty('--first-col-w',  c1.offsetWidth + 'px');
    if (c2) tbl.style.setProperty('--second-col-w', c2.offsetWidth + 'px');
    tbl.style.setProperty('--scroll-x', tbl.scrollLeft + 'px');
    updateBullets();
  }

  function startAuto() {
    if (autoInterval) return;
    autoInterval = setInterval(() => {
      const target = autoDir > 0 ? SNAP_2 : 0;
      tbl.scrollTo({ left: target, behavior: 'smooth' });
      autoDir *= -1;
    }, STEP_MS);
  }

  function stopAuto() {
    if (autoInterval) {
      clearInterval(autoInterval);
      autoInterval = null;
    }
  }

  function resetInactivity() {
    stopAuto();
    if (autoTimer) clearTimeout(autoTimer);
    autoTimer = setTimeout(startAuto, INACTIVITY_MS);
  }

  const userEvents = ['scroll', 'wheel', 'touchstart', 'pointerdown', 'keydown', 'mouseenter', 'focusin'];
  userEvents.forEach(evt => tbl.addEventListener(evt, resetInactivity, { passive: true }));

  if (bullets.length >= 2) {
    bullets[0].addEventListener('click', () => { tbl.scrollTo({ left: 0,      behavior: 'smooth' }); resetInactivity(); });
    bullets[1].addEventListener('click', () => { tbl.scrollTo({ left: SNAP_2, behavior: 'smooth' }); resetInactivity(); });
  }

  document.addEventListener('visibilitychange', () => {
    if (document.hidden) {
      stopAuto();
    } else {
      resetInactivity();
    }
  });

  window.addEventListener('load', schedule, { passive: true });
  window.addEventListener('resize', schedule, { passive: true });
  window.addEventListener('orientationchange', schedule, { passive: true });
  tbl.addEventListener('scroll', schedule, { passive: true });

  const ro = new ResizeObserver(schedule);
  if (c1) ro.observe(c1);
  if (c2) ro.observe(c2);

  schedule();
  resetInactivity();
})();
// document.addEventListener("DOMContentLoaded", () => {
//   const MOBILE_MAX = 749;

//   const table = document.querySelector("table.table");
//   if (!table) return;

//   const wrapper =
//     document.querySelector(".table_scroll_wrapper") ||
//     table.parentElement ||
//     table;

//   const headerCell = document.querySelector(".dynamic-header-cell");
//   const headerItems = headerCell ? [...headerCell.querySelectorAll(".dynamic-item")] : [];
//   const bodyCols   = [...document.querySelectorAll(".dynamic_column")];

//   if (!headerCell || !headerItems.length || !bodyCols.length) return;

//   function getFirstColWidth() {
//     const firstHeaderTd = table.querySelector(".ingredient_title_top");
//     const firstBodyTd   = table.querySelector(".ingredient_title");
//     const base = firstHeaderTd || firstBodyTd;
//     return base ? Math.ceil(base.getBoundingClientRect().width) : 160;
//   }

//   const stateCount = headerItems.length;
//   let colW = 0, firstColW = 0, posX = 0;
//   let headerTrack = null;
//   const bodyTracks = [];

//   function makeViewportWithTrack(tdContainer, items, isBody = false) {
//     tdContainer.style.width    = `${colW}px`;
//     tdContainer.style.minWidth = `${colW}px`;
//     tdContainer.style.maxWidth = `${colW}px`;
//     tdContainer.style.position = tdContainer.style.position || "relative";
//     tdContainer.style.padding  = tdContainer.style.padding  || "0";

//     const viewport = document.createElement("div");
//     viewport.setAttribute("data-viewport", "true");
//     viewport.style.overflow  = "hidden";
//     viewport.style.position  = "relative";
//     viewport.style.display   = "block";
//     viewport.style.width     = `${colW}px`;

//     const track = document.createElement("div");
//     track.setAttribute("data-track", "true");
//     track.style.display       = "flex";
//     track.style.flexDirection = "row";
//     track.style.flexWrap      = "nowrap";
//     track.style.willChange    = "transform";
//     track.style.transform     = "translateX(0px)";

//     items.forEach((el) => {
//       el.style.display  = "block";
//       el.style.flex     = `0 0 ${colW}px`;
//       el.style.minWidth = `${colW}px`;
//       el.style.maxWidth = `${colW}px`;
//       el.style.position = "relative";
//       if (isBody) {
//         el.setAttribute("aria-hidden", "false");
//         el.classList.add("is-active");
//       }
//       if (el.style.removeProperty) {
//         el.style.removeProperty("visibility");
//       }
//       track.appendChild(el);
//     });

//     tdContainer.textContent = "";
//     viewport.appendChild(track);
//     tdContainer.appendChild(viewport);

//     return { viewport, track };
//   }

//   function layout() {
//     if (window.innerWidth > MOBILE_MAX) return;

//     firstColW = getFirstColWidth();
//     const viewportTotalW = wrapper.clientWidth || window.innerWidth;
//     colW = Math.max(120, viewportTotalW - firstColW);

//     wrapper.style.overflowX = "hidden"; 
//     wrapper.style.overflowY = wrapper.style.overflowY || "hidden";
//     wrapper.style.webkitOverflowScrolling = "touch";
//     wrapper.style.position = wrapper.style.position || "relative";
//     wrapper.style.touchAction = "pan-y"; 

//     const { track: hTrack } = makeViewportWithTrack(headerCell, headerItems, false);
//     headerTrack = hTrack;

//     bodyTracks.length = 0;
//     bodyCols.forEach((td) => {
//       const states = [...td.querySelectorAll(".state")];
//       if (!states.length) return;
//       const { track: bTrack } = makeViewportWithTrack(td, states, true);
//       bodyTracks.push(bTrack);
//     });

//     posX = 0;
//     applyTransform();
//   }

//   function applyTransform() {
//     const maxX = (stateCount - 1) * colW;
//     if (posX < 0) posX = 0;
//     if (posX > maxX) posX = maxX;
//     const tx = `translateX(-${posX}px)`;
//     if (headerTrack) headerTrack.style.transform = tx;
//     bodyTracks.forEach((t) => (t.style.transform = tx));
//   }

  
//   let dragging = false, startX = 0, startY = 0, startPos = 0;
//   let v = 0;                  
//   let rafId = null;
//   let lastT = 0;

  
//   let gestureLock = null;
//   const ANGLE_THRESHOLD = 6; 

//   const trail = [];
//   const TRAIL_MAX = 6;

//   function momentumStep(t) {
//     if (!lastT) lastT = t;
//     const dt = t - lastT;
//     lastT = t;

//     const FRICTION = 0.0028;
//     posX += v * dt;
//     const decay = Math.max(0, 1 - FRICTION * dt);
//     v *= decay;

//     const maxX = (stateCount - 1) * colW;
//     if (posX < 0) { posX = 0; v = 0; }
//     else if (posX > maxX) { posX = maxX; v = 0; }

//     applyTransform();

//     if (Math.abs(v) < 0.02) {
//       cancelAnimationFrame(rafId);
//       rafId = null;
//       return;
//     }
//     rafId = requestAnimationFrame(momentumStep);
//   }

//   function startMomentum(initialV) {
//     if (rafId) cancelAnimationFrame(rafId);
//     v = initialV || 0;
//     lastT = 0;
//     rafId = requestAnimationFrame(momentumStep);
//   }

//   function stopMomentum() {
//     if (rafId) cancelAnimationFrame(rafId);
//     rafId = null;
//     v = 0;
//     lastT = 0;
//   }

//   function onDown(x, y) {
//     dragging = true;
//     gestureLock = null;              
//     startX = x;
//     startY = y;
//     startPos = posX;
//     trail.length = 0;
//     trail.push({ t: performance.now(), x });
//     stopMomentum();
//   }

//   function onMove(x, y, e) {
//     if (!dragging) return;

//     const dx = x - startX;
//     const dy = y - startY;

    
//     if (gestureLock == null) {
//       if (Math.abs(dx) > Math.abs(dy) + ANGLE_THRESHOLD) {
//         gestureLock = 'h'; 
//       } else if (Math.abs(dy) > Math.abs(dx) + ANGLE_THRESHOLD) {
//         gestureLock = 'v'; 
//       } else {
        
//         return;
//       }
//     }

//     if (gestureLock === 'v') {
      
//       return;
//     }

    
//     const now = performance.now();
//     posX = startPos - dx;
//     applyTransform();

//     trail.push({ t: now, x });
//     if (trail.length > TRAIL_MAX) trail.shift();

//     if (e) e.preventDefault(); 
//   }

//   function onUp() {
//     if (!dragging) return;
//     dragging = false;

//     if (gestureLock !== 'h') {
      
//       return;
//     }

    
//     const now = performance.now();
//     let i = trail.length - 1;
//     let j = i;
//     while (j > 0 && now - trail[j].t < 120) j--;
//     const a = trail[j], b = trail[i];
//     const dt = b.t - a.t;
//     const dx = b.x - a.x;
//     const initialV = dt > 0 ? (-dx / dt) : 0;

//     if (Math.abs(initialV) > 0.05) {
//       startMomentum(initialV);
//     }
//   }

  
//   wrapper.addEventListener("mousedown", (e) => onDown(e.pageX, e.pageY));
//   window.addEventListener("mousemove", (e) => onMove(e.pageX, e.pageY, e));
//   window.addEventListener("mouseup", onUp);

  
//   wrapper.addEventListener("touchstart", (e) => {
//     const t = e.touches[0];
//     onDown(t.pageX, t.pageY);
//   }, { passive: true });

//   wrapper.addEventListener("touchmove", (e) => {
//     const t = e.touches[0];
//     onMove(t.pageX, t.pageY, e);
//   }, { passive: false });

//   wrapper.addEventListener("touchend", onUp);

  
//   wrapper.addEventListener("wheel", (e) => {
//     const absX = Math.abs(e.deltaX);
//     const absY = Math.abs(e.deltaY);
//     if (absX > absY) {
      
//       stopMomentum();
//       posX += e.deltaX;
//       applyTransform();
//       e.preventDefault();        
//       startMomentum(e.deltaX / 16.6);
//     } else {
      
      
//     }
//   }, { passive: false });

//   let rt;
//   function onResize() {
//     clearTimeout(rt);
//     rt = setTimeout(() => {
//       stopMomentum();
//       const prevColW = colW;
//       layout();
//       if (prevColW !== colW) {
//         applyTransform();
//       }
//     }, 120);
//   }

//   layout();
//   window.addEventListener("resize", onResize, { passive: true });
// });

// (() => {
// const tbl = document.querySelector('.product-comparison-chart .comparison-chart-table');
// if (!tbl) return;

// const row = (tbl.tBodies[0]?.rows[0]) || tbl.rows[0];
// const c1  = row?.cells[0];
// const c2  = row?.cells[1];

// let raf = null;
// const schedule = () => { if (raf == null) raf = requestAnimationFrame(update); };

// function update() {
//   raf = null;
//   if (c1) tbl.style.setProperty('--first-col-w',  c1.offsetWidth + 'px');
//   if (c2) tbl.style.setProperty('--second-col-w', c2.offsetWidth + 'px');
//   tbl.style.setProperty('--scroll-x', tbl.scrollLeft + 'px');
// }

// window.addEventListener('load', schedule, { passive: true });
// window.addEventListener('resize', schedule, { passive: true });
// window.addEventListener('orientationchange', schedule, { passive: true });
// tbl.addEventListener('scroll', schedule, { passive: true });

// const ro = new ResizeObserver(schedule);
// if (c1) ro.observe(c1);
// if (c2) ro.observe(c2);

// schedule();
// })();